import { useUnit } from 'effector-react'
import * as React from 'react'

import {
  $bonus150,
  $bonus150Error,
  bonus150Mounted,
  getBonus150Participant,
  banParticipantTriggered,
  unbanParticipantTriggered,
  updateParticipantFx,
} from './model'

export const useBonus150Widget = () => {
  React.useEffect(() => {
    bonus150Mounted()
  }, [])

  const bonus150 = useUnit($bonus150)
  const error = useUnit($bonus150Error)
  const loading = useUnit(getBonus150Participant.pending)
  const updateLoading = useUnit(updateParticipantFx.pending)

  return {
    bonus150,
    loading,
    error,
    updateLoading,
    banParticipant: banParticipantTriggered,
    unbanParticipant: unbanParticipantTriggered,
  }
}
